const DISMISSED_KEY = 'collection-import-notice-dismissed'

export function setCollectionImportNoticeVisible(
	element: HTMLElement | null,
	visible: boolean,
	respectDismissal = false,
): void {
	if (!element) return
	element.hidden =
		!visible || (respectDismissal && !!localStorage.getItem(DISMISSED_KEY))
}

export function dismissCollectionImportNotice(
	element: HTMLElement | null,
): void {
	localStorage.setItem(DISMISSED_KEY, 'true')
	setCollectionImportNoticeVisible(element, false)
}
